import AuthPageLayout from "../components/AuthPageLayout/AuthPageLayout";
import { OtpForm } from "../components/Form/OtpForm";

const OtpPage = () => {
  return (
    <AuthPageLayout>
      <OtpForm />
    </AuthPageLayout>
  );
};

export default OtpPage;
